/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EstimatedActivity,
  EstimatedActivity$inboundSchema,
  EstimatedActivity$Outbound,
  EstimatedActivity$outboundSchema,
} from "./estimatedactivity.js";

export type SendFundsInstantBank = {
  estimatedActivity?: EstimatedActivity | undefined;
};

/** @internal */
export const SendFundsInstantBank$inboundSchema: z.ZodType<
  SendFundsInstantBank,
  z.ZodTypeDef,
  unknown
> = z.object({
  estimatedActivity: EstimatedActivity$inboundSchema.optional(),
});
/** @internal */
export type SendFundsInstantBank$Outbound = {
  estimatedActivity?: EstimatedActivity$Outbound | undefined;
};

/** @internal */
export const SendFundsInstantBank$outboundSchema: z.ZodType<
  SendFundsInstantBank$Outbound,
  z.ZodTypeDef,
  SendFundsInstantBank
> = z.object({
  estimatedActivity: EstimatedActivity$outboundSchema.optional(),
});

export function sendFundsInstantBankToJSON(
  sendFundsInstantBank: SendFundsInstantBank,
): string {
  return JSON.stringify(
    SendFundsInstantBank$outboundSchema.parse(sendFundsInstantBank),
  );
}
export function sendFundsInstantBankFromJSON(
  jsonString: string,
): SafeParseResult<SendFundsInstantBank, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SendFundsInstantBank$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SendFundsInstantBank' from JSON`,
  );
}
